<mat-slide-toggle [(ngModel)]="toggleStatus" [labelPosition]="labelPosition" (change)="onToggleChange($event)">
    <div class="slide-title">{{label}}</div>
    <br>
    <span *ngIf="showSubtitle" class="slide-subtitle">{{subtitleLabel}}</span>
</mat-slide-toggle>